import { useNavigate } from "@tanstack/react-router";
import { FileText } from "lucide-react";

import { Button } from "@/components/button";
import { AlphaStepLayout } from "@/features/request/alpha/layout/AlphaStepLayout";

type AlphaStepFrameProps = {
  children: React.ReactNode;
  onBack: () => void;
  onViewBrief?: () => void;
  primaryAction: React.ReactNode;
  step: "Prompt" | "Styles";
};

export function AlphaStepFrame({
  children,
  onBack,
  onViewBrief,
  primaryAction,
  step,
}: AlphaStepFrameProps) {
  const navigate = useNavigate();

  return (
    <AlphaStepLayout
      actions={
        <>
          {onViewBrief ? (
            <Button
              aria-label="View brief"
              onPress={onViewBrief}
              size="sm"
              variant="tertiary"
            >
              <FileText className="size-4" />
              <span className="hidden md:inline">View brief</span>
            </Button>
          ) : null}
          <Button
            color="gray"
            onPress={() =>
              void navigate({ to: "/ai-ad-studio", viewTransition: true })
            }
            size="sm"
            variant="tertiary"
          >
            Cancel
          </Button>
        </>
      }
      activeStep={step}
      className="h-full"
      footer={
        <>
          <Button color="gray" onPress={onBack} variant="secondary">
            Back
          </Button>
          {primaryAction}
        </>
      }
    >
      {children}
    </AlphaStepLayout>
  );
}
